import {
  Backdrop,
  Box,
  CircularProgress,
  Typography,
  useMediaQuery,
} from "@mui/material";
import React, { useState } from "react";
import AuthLayout from "../../layout/AuthLayout";
import { colors } from "../../theme/theme";
import {
  CustomInput,
  CustomPasswordInput,
} from "../../components/Common/CustomInput";
import { EmailOutlined } from "@mui/icons-material";
import { CustomBtn } from "../../components/Common/CustomBtn";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../../utils/config/config";
import { useDispatch } from "react-redux";
import {
  getUserById,
  setAuthenticationState,
} from "../../redux/dispatchers/users.dispatcher";
import { ErrorSnackbar } from "../../components/Common/CustomSnackbar";

const SignIn = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const smScreen = useMediaQuery((theme) => theme.breakpoints.down("sm"));
  const mdScreen = useMediaQuery((theme) => theme.breakpoints.down("md"));

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const [loading, setLoading] = useState(false);
  const [errorState, setErrorState] = useState({
    error: false,
    errorMsg: "",
  });

  const handleSignIn = async () => {
    setErrorState({
      error: false,
      errorMsg: "",
    });

    if (!email || !password) {
      setErrorState({
        error: true,
        errorMsg: "Please fill all the fields",
      });
      return;
    }
    try {
      setLoading(true);
      const response = await axiosInstance.post("/user/login", {
        email,
        password,
      });

      if (response.status === 200) {
        setLoading(false);
        dispatch(setAuthenticationState(true));
        dispatch(getUserById());
      }
    } catch (error) {
      console.log(error?.response?.data?.message, "error in signin");
      setErrorState({
        error: true,
        errorMsg:
          error?.response?.data?.message ||
          "Something went wrong. Please try again.",
      });
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthLayout fullHeight>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <ErrorSnackbar
        error={errorState.error}
        handleCloseError={() => setErrorState({ error: false, errorMsg: "" })}
        errorMsg={errorState.errorMsg}
      />
      <Box
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            handleSignIn();
          }
        }}
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          gap: 1,
          height: "100%",
        }}
      >
        <Typography
          sx={{
            color: colors.primary,
            fontSize: "28px",
            fontFamily: "Mulish-ExtraBold",
            textAlign: "center",
          }}
        >
          Welcome Back! 👋
        </Typography>
        <Typography
          sx={{
            color: colors.primary,
            fontSize: "14px",
            fontFamily: "Mulish-SemiBold",
          }}
        >
          Enter your credentials to join the conversation.
        </Typography>

        <Box
          sx={{
            width: "100%",
            height: "100%",
            mt: 2,
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            alignItems: "center",
            gap: 2,
          }}
        >
          <Box>
            <CustomInput
              label="Email address"
              placeholder="e.g., hello@imzul.com"
              type={"email"}
              Icon={EmailOutlined}
              width={"100%"}
              mT={2}
              value={email}
              handleChange={(e) => setEmail(e.target.value)}
            />
            <CustomPasswordInput
              label="Password"
              placeholder="e.g., ********"
              width={"100%"}
              mT={2}
              value={password}
              handleChange={(e) => setPassword(e.target.value)}
            />
          </Box>

          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              mt: 4,
              gap: 2,
              width: "100%",
            }}
          >
            <Typography
              sx={{
                color: colors.secondary,
                fontFamily: "Mulish-Regular",
                fontSize: "12px",
                cursor: "pointer",
                textDecoration: "underline",
                mb: 3,
              }}
              onClick={() => navigate("/forgot-password")}
            >
              Forgot password?{" "}
            </Typography>
            <CustomBtn
              width={smScreen ? "100%" : mdScreen ? "75%" : "40%"}
              text="Sign In"
              icon
              fontSize={"16px"}
              onClick={handleSignIn}
            />

            <Typography
              sx={{
                color: colors.primary,
                fontFamily: "Mulish-Regular",
                fontSize: "12px",
              }}
            >
              Don't have an account?{" "}
              <Typography
                component={"span"}
                sx={{
                  color: colors.secondary,
                  fontFamily: "Mulish-Bold",
                  fontSize: "12px",
                  cursor: "pointer",
                  textDecoration: "underline",
                }}
                onClick={() => navigate("/sign-up")}
              >
                Sign Up
              </Typography>
            </Typography>
          </Box>
        </Box>
      </Box>
    </AuthLayout>
  );
};

export default SignIn;
